var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6218_19102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.99991H4L9.25 4.74991C9.38132 4.61859 9.48549 4.46268 9.55656 4.2911C9.62763 4.11952 9.66421 3.93562 9.66421 3.74991C9.66421 3.56419 9.62763 3.38029 9.55656 3.20871C9.48549 3.03713 9.38132 2.88123 9.25 2.74991C9.11868 2.61859 8.96278 2.51442 8.7912 2.44334C8.61962 2.37227 8.43572 2.33569 8.25 2.33569C8.06428 2.33569 7.88038 2.37227 7.7088 2.44334C7.53722 2.51442 7.38132 2.61859 7.25 2.74991L2 7.99991V9.99991Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.25L8.75 5.25",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6218_19102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBarIcon);
export default __webpack_public_path__ + "static/media/EditBarIcon.b1d8564fb49dc12fe72424e0c915791e.svg";
export { ForwardRef as ReactComponent };